
export const ReportInfo = ({ totalSites, startDate, endDate }) => {
  return (
    <div className="bg-slate-50 border rounded-lg p-4 mb-5">
      <h2 className="lg:text-lg font-semibold text-slate-800">Visit Report</h2>

      <p className="text-xs lg:text-sm text-slate-500 mt-1">
        Export visit records including Site details, Engineer information,
        Complaint and Regular visits.
      </p>

      <div className="flex flex-wrap items-center gap-3 mt-4">
        <DateDisplay date={startDate} label="Start Date" />
        <span className="text-slate-400">→</span>
        <DateDisplay date={endDate} label="End Date" />

        <div className="text-xs text-blue-700 font-figtreeMedium ml-auto p-2 bg-blue-100 border border-blue-200 rounded-lg text-center">
          Total Sites: {totalSites}
        </div>
      </div>
    </div>
  );
};

const DateDisplay = ({ date, label }) => {
  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-white border rounded-lg text-[10px] lg:text-xs">
      <span className="font-medium text-slate-500 uppercase">
        {label}
      </span>
      <span className="font-semibold text-slate-800">{date}</span>
    </div>
  );
};
